import React, { useEffect, useRef, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import api from "../../../api";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

const GeoMaster = () => {

  const currentDate1 = new Date();
  const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
  const userID = sessionStorage.getItem("UserID");
  const roleID = sessionStorage.getItem("RoleID");
  const stateID = sessionStorage.getItem("stateID");
  const stateName = sessionStorage.getItem("stateName");
  const dt = useRef(null);


    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const getUserData = async () => {
      try {
        const requestData = {
          logged_in_userid: userID,
          role_id: roleID,
          state_id: "",
          synceddatetime: formattedCurrentDate,
          FormCode: "214",
          ApiKey: "kavin",
          AppTypeNo: "3",
          AppVersion: "1.0.0",
          data_source: "W",
        };
    
        const result = await api.get_User_Data(requestData);
    
        // State Data
        const stateData = result.phc_details.map((state) => ({
          label: state.fld_state_name,
          value: state.fld_state_name,
          state_code: state.fld_state_id,
          state_swid: state.fld_state_sw_id,
        }));
        setState(stateData);
    
        // District Data
        const distData = result.phc_details.map((district) => ({
          label: district.fld_district_name,
          value: district.fld_district_name,
          district_code: district.fld_district_id,
          district_swid: district.fld_district_sw_id,
        }));
        setDistrict(distData);
    
        // Site Data
        const siteData = result.phc_details.map((site) => ({
          label: site.fld_site_name,
          value: site.fld_site_name,
          site_code: site.fld_site_id,
          site_swid: site.fld_site_sw_id,
        }));
        setSite(siteData);
    
        if (roleID === "2") {
          // Prebind State
          const currentState = stateData.find(
            (stateObj) => stateObj.value === result.phc_details[0].fld_state_name
          );
          setSelectedState(currentState);
          formik.setFieldValue("state_name", currentState?.value || "");
          formik.setFieldValue("state_code", currentState?.state_code || "");
          formik.setFieldValue("state_sw_id", currentState?.state_swid || "");
    
          // Prebind District
          const currentDist = distData.find(
            (distObj) => distObj.value === result.phc_details[0].fld_district_name
          );
          setSelectedDistrict(currentDist);
          formik.setFieldValue("district_name", currentDist?.value || "");
          formik.setFieldValue("district_code", currentDist?.district_code || "");
          formik.setFieldValue("district_sw_id", currentDist?.district_swid || "");
    
          // Prebind Site
          const currentSite = siteData.find(
            (siteObj) => siteObj.value === result.phc_details[0].fld_site_name
          );
          setSelectedSite(currentSite);
          formik.setFieldValue("site_name", currentSite?.value || "");
          formik.setFieldValue("site_code", currentSite?.site_code || "");
          formik.setFieldValue("site_swid", currentSite?.site_swid || "");
    
          if (roleID === "2") {
          
            getTaluk(
              currentState?.state_code,
              currentState?.state_swid,
              currentDist?.district_code,
              currentDist?.district_swid,
              currentSite?.site_code,
              currentSite?.site_swid
            );
          }
        }
      } catch (error) {
        console.error("Error fetching User Data:", error);
      }
    };
    
    useEffect(() => {
      if (roleID === "2") {
        getUserData();
      }
    }, [roleID]);

  const [selectedState, setSelectedState] = useState({ state_code: "" });
  const [selectedDistrict, setSelectedDistrict] = useState({ district_code: "" });
  const [selectedSite, setSelectedSite] = useState({ site_code: "" });
  const [selectedTaluk, setSelectedTaluk] = useState({ taluk_code: "" });
  const [selectedPRS, setSelectedPRS] = useState({ prs_code: "" });
  const [selectedVillage, setSelectedVillage] = useState({ village_code: "" });
  const [selectedType, setSelectedType] = useState("");



  const typeName = [
    { id: "1", label: "Control" },
    { id: "2", label: "Intervention" },
  ];

  const [state, setState] = useState([]);
  const getStates = async () => {
    try {
      const requestData = {
        logged_in_userid : userID,
        synceddatetime : formattedCurrentDate,
        FormCode : "202",
        ApiKey : "kavin",
        AppTypeNo : "3",
        AppVersion : "1.0.0",
        data_source : "W"
      };

      const result = await api.get_States(requestData);
      const statesData = result.geo_master_state.map((state) => ({
        label: state.fld_state_name,
        value: state.fld_state_name,
        state_code: state.fld_state_id,
        state_swid: state.fld_state_sw_id
      }));
      setState(statesData);
    } catch (error) {
      console.error("Error fetching state:", error);
    }
  };

  useEffect(() => {
    getStates();
  }, []);

  const [district, setDistrict] = useState([]);
  const getDistrict = async (state_id, state_sw_id) => {
    try {
      const requestData = {
        logged_in_userid : userID,
        state_sw_id,
        state_id,
        synceddatetime : formattedCurrentDate,
        FormCode : "202",
        ApiKey : "kavin",
        AppTypeNo : "3",
        AppVersion : "1.0.0",
        data_source : "W"
      };

      const result = await api.get_District(requestData);
      const districtData = result.geo_master_district.map((district) => ({
        label: district.fld_district_name,
        value: district.fld_district_name,
        district_code: district.fld_district_id,
        district_swid: district.fld_district_sw_id
      }));
      setDistrict(districtData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };


  const [site, setSite] = useState([]);
  const getSite = async (state_id, state_sw_id, district_id, district_sw_id) => {
    try {
      const requestData = {
        logged_in_userid : userID,
        state_id,
        state_sw_id,
        district_id,
        district_sw_id,
        synceddatetime : formattedCurrentDate,
        FormCode : "202",
        ApiKey : "kavin",
        AppTypeNo : "3",
        AppVersion : "1.0.0",
        data_source : "W"
      };

      const result = await api.get_Site(requestData);
      const siteData = result.geo_master_site.map((site) => ({
        label: site.fld_site_name,
        value: site.fld_site_name,
        site_code: site.fld_site_id,
        site_swid: site.fld_site_sw_id
      }));
      setSite(siteData);
    } catch (error) {
      console.error("Error fetching site:", error);
    }
  };

  const [taluk, setTaluk] = useState([]);
  const getTaluk = async (state_id, state_sw_id, district_id, district_sw_id, site_id, site_sw_id) => {
    try {
      const requestData = {
        logged_in_userid : userID,
        state_sw_id ,
        state_id ,
        district_sw_id ,
        district_id ,
        site_sw_id ,
        site_id ,
        synceddatetime : formattedCurrentDate,
        FormCode : "202",
        ApiKey : "kavin",
        AppTypeNo : "3",
        AppVersion : "1.0.0",
        data_source : "W"
      };

      const result = await api.get_Taluk(requestData);
      const talukData = result.geo_master_taluk.map((taluk) => ({
        label: taluk.fld_taluk_name,
        value: taluk.fld_taluk_name,
        taluk_code: taluk.fld_taluk_id,
        taluk_swid: taluk.fld_taluk_sw_id
      }));
      setTaluk(talukData);
    } catch (error) {
      console.error("Error fetching taluk:", error);
    }
  };

  const [prs, setPRS] = useState([]);
  const [village, setVillage] = useState([]);
  const getVillage = async (state_id, state_sw_id, district_id, district_sw_id, site_id, site_sw_id, taluk_id, taluk_sw_id) => {
    try {
      const requestData = {
         logged_in_userid : userID,
         state_sw_id ,
         state_id ,
         district_sw_id ,
         district_id ,
         site_sw_id ,
         site_id ,
         taluk_sw_id ,
         taluk_id ,
         synceddatetime : formattedCurrentDate,
         FormCode : "202",
         ApiKey : "kavin",
         AppTypeNo : "3",
         AppVersion : "1.0.0",
         data_source : "W"
      };

      const result = await api.get_Village(requestData);
      const villageData = result.geo_master_village.map((village) => ({
        label: village.fld_village_name,
        value: village.fld_village_name,
        village_code: village.fld_village_id,
        village_swid: village.fld_village_sw_id
      }));
      setVillage(villageData);

      const prsData = result.user_details.map((village) => ({
        label: village.fld_user_name,
        value: village.fld_user_name,
        prs_code: village.fld_user_code,
        prs_userID: village.fld_user_id,
        prs_swid: village.fld_user_sw_id
      }));
      setPRS(prsData);
    } catch (error) {
      console.error("Error fetching village:", error);
    }
  };

  const [geoList, setGeoList] = useState([]);
  const getGeo = async () => {
    try {
      setLoading(true);
      const requestData = {
        role_id: roleID,
        logged_in_userid: userID,
        state_id : stateID || "",
        synceddatetime: formattedCurrentDate,
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };
      const result = await api.get_Created_Geo(requestData);
        const responseData = result.phc_details;
        const slNo = responseData.map((item, index) => ({
                   ...item, slno: index + 1
               }));
               setGeoList(slNo);
    } catch (error) {
      console.error("Error fetching requested data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getGeo();
  }, []);


  const [globalFilter, setGlobalFilter] = useState('');

  const onFilterInputChange = (e) => {
    setGlobalFilter(e.target.value);
  };
  const filteredData = geoList.filter((role) =>
  Object.values(role).some((value) => {
    if (value === null || value === undefined) {
      return false;
    }
    return value.toString().toLowerCase().includes(globalFilter.toLowerCase());
  })
);

  const header = () => {
    return (
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search">
              </InputIcon>
              <InputText value={globalFilter} onChange={onFilterInputChange} placeholder="Search" />
            </IconField>
    );
};


  const formik = useFormik({
    initialValues: {
      state_name: "",
      district_name: "",
      site_name:"",
      taluk_name:"",
      prs_name:"",
      village_name:"",
      phc_name:"",
      phc_type_name:""
    },
    validationSchema: Yup.object({
      state_name: Yup.string().required("State is required"),
      district_name: Yup.string().required("District Name is required"),
      site_name: Yup.string().required("Site Code is required"),
      taluk_name: Yup.string().required("Taluk Name is required"),
      prs_name: Yup.string().required("PRS Name is required"),
      village_name: Yup.string().required("Village Name is required"),
      phc_name: Yup.string().required("PHC Name is required"),
      phc_type_name: Yup.string().required("PHC Type is required"),


    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const additionalData = {
          // state_id: selectedState?.state_code || "",
          state_id: values.state_code,
          district_id: values.district_code,
          site_id: values.site_code,
          taluk_id: values.taluk_code,
          fld_mapped_prs_id: values.prs_userID,
          village_id: values.village_code,
          phc_name: values.phc_name,
          phc_type_name: values.phc_type_name,
          phc_type_id: values.phc_type_id,
          synceddatetime: formattedCurrentDate,
          FormCode: "202",
          ApiKey: "kavin",
          AppTypeNo: "3",
          AppVersion: "1.0.0",
          data_source: "W",
          loggedin_user_id: userID,
        };

        const response = await api.add_PHC(additionalData);

        if (response && response.status === "1") {
          toast.current.show({
            severity: "success",
            summary: "PHC Created Successful",
            detail:
              response.responsemessage ||
              "You have successfully created the PHC.",
          });
          resetForm();
          setSelectedType(null);
          getGeo();
      if (roleID === "2") {
          getUserData();
      }
        } else {
          throw new Error(
            response
              ? response.responsemessage ||
                "An error occurred while creating the PHC."
              : "No response from the server."
          );
        }
      } catch (error) {
        console.error("PHC submission error:", error);

        toast.current.show({
          severity: "error",
          summary: " PHC Failed",
          detail:
            error.message || "An unexpected error occurred. Please try again.",
        });
      } finally {
        setLoading(false);
    }
    },
  });

  return (
    <div>
     <Toast ref={toast} position="top-right" />
                {loading && (
                    <div className="backdrop">
                        <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                    </div>
                )}
      <form onSubmit={formik.handleSubmit}>

        <div className="grid flex align-items-baseline mt-3 gap-8">
            <div className="col-2 p-0 ml-8">
              <div className="formslabel">State Name</div>
            </div>
            <div className="col p-0 flex justify-content-start flex-column">
              <Dropdown
                id="state_name"
                name="state_name"
                  optionLabel="label"
                placeholder={stateName || "Select State"}
                value={formik.values.state_name}

                className={
                  formik.errors.state_name && formik.touched.state_name
                    ? "p-invalid p-inputtext forminputtext-invalid"
                    : "p-inputtext forminputtext"
                }
                options={state}
                disabled={roleID === "2"}
                onChange={(e) => {
                  const selectedState = state.find(
                    (stateObj) => stateObj.value === e.value
                  );
                  setSelectedState(selectedState);
                  formik.setFieldValue("state_name", e.value);
                  if (selectedState) {
                    formik.setFieldValue("state_code", selectedState.state_code || "");
                    formik.setFieldValue("state_sw_id", selectedState.state_swid || "");

                    getDistrict(selectedState.state_code, selectedState.state_swid);

                  } else {
                    formik.setFieldValue("state_code", "");
                    formik.setFieldValue("state_sw_id", "");
                    setDistrict([]);
                  }

                  formik.setFieldValue("district_name", "");
                  formik.setFieldValue("district_code", "");
                  formik.setFieldValue("district_sw_id", "");
                  setSelectedDistrict({});
                  setDistrict([])

                  formik.setFieldValue("site_name", "");
                  formik.setFieldValue("site_code", "");
                  formik.setFieldValue("site_sw_id", "");
                  setSelectedSite({});
                  setSite([]);

                  formik.setFieldValue("taluk_name", "");
                  formik.setFieldValue("taluk_code", "");
                  formik.setFieldValue("taluk_sw_id", "");
                  setSelectedTaluk({});
                  setTaluk([]);

                  formik.setFieldValue("prs_name", "");
                  formik.setFieldValue("prs_userID", "");
                  formik.setFieldValue("prs_swid", "");
                  setSelectedPRS({});
                  setPRS([]);

                  formik.setFieldValue("village_name", "");
                  formik.setFieldValue("village_code", "");
                  formik.setFieldValue("village_sw_id", "");
                  setSelectedVillage({});
                  setVillage([]);

                  formik.setFieldValue("phc_name", "");
                }}
                // onBlur={formik.handleBlur}
              />
              {formik.errors.state_name && formik.touched.state_name && (
                <span className="p-error mt-1" style={{fontSize:"12px"}}>{formik.errors.state_name}</span>
              )}
            </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 gap-8">
          <div className="col-2 p-0 ml-8">
            <div className="formslabel">District Name</div>
          </div>
          <div className="col p-0 flex justify-content-start flex-column">
              <Dropdown
                id="district_name"
                name="district_name"
                placeholder="Select District"
                value={formik.values.district_name}
                className={
                  formik.errors.district_name && formik.touched.district_name
                    ? "p-invalid p-inputtext forminputtext-invalid"
                    : "p-inputtext forminputtext"
                }
                options={district}
                disabled={roleID === "2"}

                onChange={(e) => {
                  const selectedDistrict = district.find(
                    (districtObj) => districtObj.value === e.value
                  );
                  setSelectedDistrict(selectedDistrict);
                  formik.setFieldValue("district_name", e.value);
              
                  if (selectedDistrict) {
                    formik.setFieldValue("district_code", selectedDistrict.district_code || "");
                    formik.setFieldValue("district_sw_id", selectedDistrict.district_swid || "");
              
                    getSite(
                      selectedState.state_code, // Assuming this holds the selected state_id
                      selectedState.state_swid, // Assuming this holds the selected state_sw_id
                      selectedDistrict.district_code,
                      selectedDistrict.district_swid
                    );
                  } else {
                    formik.setFieldValue("district_code", "");
                    formik.setFieldValue("district_sw_id", "");
                    setTaluk([]);
                  }

                  formik.setFieldValue("site_name", "");
                  formik.setFieldValue("site_code", "");
                  formik.setFieldValue("site_sw_id", "");
                  setSelectedSite({});
                  setSite([]);

                  formik.setFieldValue("taluk_name", "");
                  formik.setFieldValue("taluk_code", "");
                  formik.setFieldValue("taluk_sw_id", "");
                  setSelectedTaluk({});
                  setTaluk([]);

                  formik.setFieldValue("prs_name", "");
                  formik.setFieldValue("prs_userID", "");
                  formik.setFieldValue("prs_swid", "");
                  setSelectedPRS({});
                  setPRS([]);

                  formik.setFieldValue("village_name", "");
                  formik.setFieldValue("village_code", "");
                  formik.setFieldValue("village_sw_id", "");
                  setSelectedVillage({});
                  setVillage([]);

                  formik.setFieldValue("phc_name", "");
                }}
                // onBlur={formik.handleBlur}
              />
              {formik.errors.district_name && formik.touched.district_name && (
                <span className="p-error mt-1" style={{fontSize:"12px"}}>{formik.errors.district_name}</span>
              )}
            </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 gap-8">
          <div className="col-2 p-0 ml-8">
            <div className="formslabel">Site Name</div>
          </div>
          <div className="col p-0 flex justify-content-start flex-column">
              <Dropdown
                id="site_name"
                name="site_name"
                placeholder="Select Site"
                value={formik.values.site_name}
                className={
                  formik.errors.site_name && formik.touched.site_name
                    ? "p-invalid p-inputtext forminputtext-invalid"
                    : "p-inputtext forminputtext"
                }
                options={site}
                disabled={roleID === "2"}

                onChange={(e) => {
                  const selectedSite = site.find(
                    (siteObj) => siteObj.value === e.value
                  );
                  setSelectedSite(selectedSite);
                  formik.setFieldValue("site_name", e.value);
              
                  if (selectedSite) {
                    formik.setFieldValue("site_code", selectedSite.site_code || "");
                    formik.setFieldValue("site_sw_id", selectedSite.site_swid || "");

                    getTaluk(
                      selectedState.state_code, // Assuming this holds the selected state_id
                      selectedState.state_swid, // Assuming this holds the selected state_sw_id
                      selectedDistrict.district_code, // Assuming this holds the selected district_id
                      selectedDistrict.district_swid, // Assuming this holds the selected district_sw_id
                      selectedSite.site_code,
                      selectedSite.site_swid
                    );
                  } else {
                    formik.setFieldValue("site_code", "");
                    formik.setFieldValue("site_sw_id", "");
                    setSite([]);
                  }

                  formik.setFieldValue("taluk_name", "");
                  formik.setFieldValue("taluk_code", "");
                  formik.setFieldValue("taluk_sw_id", "");
                  setSelectedTaluk({});
                  setTaluk([]);

                  formik.setFieldValue("prs_name", "");
                  formik.setFieldValue("prs_userID", "");
                  formik.setFieldValue("prs_swid", "");
                  setSelectedPRS({});
                  setPRS([]);

                  formik.setFieldValue("village_name", "");
                  formik.setFieldValue("village_code", "");
                  formik.setFieldValue("village_sw_id", "");
                  setSelectedVillage({});
                  setVillage([]);

                  formik.setFieldValue("phc_name", "");
                }}
                // onBlur={formik.handleBlur}
              />
              {formik.errors.site_name && formik.touched.site_name && (
                <span className="p-error mt-1" style={{fontSize:"12px"}}>{formik.errors.site_name}</span>
              )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 gap-8">
          <div className="col-2 p-0 ml-8">
            <div className="formslabel">Taluk Name</div>
          </div>
          <div className="col p-0 flex justify-content-start flex-column">
              <Dropdown
                id="taluk_name"
                name="taluk_name"
                placeholder="Select Taluk"
                value={formik.values.taluk_name}
                className={
                  formik.errors.taluk_name && formik.touched.taluk_name
                    ? "p-invalid p-inputtext forminputtext-invalid"
                    : "p-inputtext forminputtext"
                }
                options={taluk}
                onChange={(e) => {
                  const selectedTaluk = taluk.find(
                    (talukObj) => talukObj.value === e.value
                  );
                  setSelectedTaluk(selectedTaluk);
                  formik.setFieldValue("taluk_name", e.value);
              
                  if (selectedTaluk) {
                    formik.setFieldValue("taluk_code", selectedTaluk.taluk_code || "");
                    formik.setFieldValue("taluk_sw_id", selectedTaluk.taluk_swid || "");

                    getVillage(
                      selectedState.state_code, // Assuming this holds the selected state_id
                      selectedState.state_swid, // Assuming this holds the selected state_sw_id
                      selectedDistrict.district_code, // Assuming this holds the selected district_id
                      selectedDistrict.district_swid, // Assuming this holds the selected district_sw_id
                      selectedSite.site_code,
                      selectedSite.site_swid,
                      selectedTaluk.taluk_code,
                      selectedTaluk.taluk_swid
                    );
                  } else {
                    formik.setFieldValue("taluk_code", "");
                    formik.setFieldValue("taluk_sw_id", "");
                    setSite([]);
                  }

                  formik.setFieldValue("village_name", "");
                  formik.setFieldValue("village_code", "");
                  formik.setFieldValue("village_sw_id", "");
                  setSelectedVillage({});
                  setVillage([]);

                  formik.setFieldValue("phc_name", "");
                }}
                // onBlur={formik.handleBlur}
              />
              {formik.errors.taluk_name && formik.touched.taluk_name && (
                <span className="p-error mt-1" style={{fontSize:"12px"}}>{formik.errors.taluk_name}</span>
              )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 gap-8">
          <div className="col-2 p-0 ml-8">
            <div className="formslabel">PRS Name</div>
          </div>
          <div className="col p-0 flex justify-content-start flex-column">
              <Dropdown
                id="prs_name"
                name="prs_name"
                placeholder="Select PRS"
                value={formik.values.prs_name}
                className={
                  formik.errors.prs_name && formik.touched.prs_name
                    ? "p-invalid p-inputtext forminputtext-invalid"
                    : "p-inputtext forminputtext"
                }
                options={prs}
                onChange={(e) => {
                  const selectedPRS = prs.find(
                    (prsObj) => prsObj.value === e.value
                  );
                  setSelectedPRS(selectedPRS);
                  formik.setFieldValue("prs_name", e.value);
              
                  if (selectedPRS) {
                    formik.setFieldValue("prs_userID", selectedPRS.prs_userID || "");
                    formik.setFieldValue("prs_swid", selectedPRS.prs_swid || "");
                  } else {
                    formik.setFieldValue("prs_userID", "");
                    formik.setFieldValue("prs_swid", "");
                  }

                  formik.setFieldValue("phc_name", "");
                }}
                // onBlur={formik.handleBlur}
              />
              {formik.errors.prs_name && formik.touched.prs_name && (
                <span className="p-error mt-1" style={{fontSize:"12px"}}>{formik.errors.village_name}</span>
              )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 gap-8">
          <div className="col-2 p-0 ml-8">
            <div className="formslabel">Village Name</div>
          </div>
          <div className="col p-0 flex justify-content-start flex-column">
              <Dropdown
                id="village_name"
                name="village_name"
                placeholder="Select Village"
                value={formik.values.village_name}
                className={
                  formik.errors.village_name && formik.touched.village_name
                    ? "p-invalid p-inputtext forminputtext-invalid"
                    : "p-inputtext forminputtext"
                }
                options={village}
                onChange={(e) => {
                  const selectedVillage = village.find(
                    (villageObj) => villageObj.value === e.value
                  );
                  setSelectedVillage(selectedVillage);
                  formik.setFieldValue("village_name", e.value);
              
                  if (selectedVillage) {
                    formik.setFieldValue("village_code", selectedVillage.village_code || "");
                    formik.setFieldValue("village_sw_id", selectedVillage.village_swid || "");
                  } else {
                    formik.setFieldValue("village_code", "");
                    formik.setFieldValue("village_sw_id", "");
                    setSite([]);
                  }

                  formik.setFieldValue("phc_name", "");
                }}
                // onBlur={formik.handleBlur}
              />
              {formik.errors.village_name && formik.touched.village_name && (
                <span className="p-error mt-1" style={{fontSize:"12px"}}>{formik.errors.village_name}</span>
              )}
          </div>
        </div>


        <div className="grid flex align-items-baseline mt-3 gap-8">
          <div className="col-2 p-0 ml-8">
            <div className=" formslabel">PHC Name</div>
          </div>
          <div className="col p-0 flex justify-content-start flex-column">
          <InputText
              id="phc_name"
              name="phc_name"
              style={{padding:"10px", fontSize:"14px"}}
              keyfilter={/^[a-zA-Z\s]*$/}
              maxLength={50}
              placeholder="Enter PHC Name"
              onChange={formik.handleChange}
              // onBlur={formik.handleBlur}
              value={formik.values.phc_name}
              className={
                formik.errors.phc_name && formik.touched.phc_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />
              {formik.errors.phc_name && formik.touched.phc_name && (
                <span className="p-error mt-1" style={{fontSize:"12px"}}>{formik.errors.phc_name}</span>
              )}
          </div>
        </div>

                <div className="grid flex align-items-baseline mt-3 gap-8">
                  <div className="col-2 p-0 ml-8">
                    <div className="formslabel">PHC Type</div>
                  </div>
                  <div className="col p-0 flex justify-content-start flex-column">
                    <Dropdown
                      id="phc_type_name"
                      name="phc_type_name"
                      placeholder="Select PHC Type"
                      className={
                        formik.errors.phc_type_name && formik.touched.phc_type_name
                          ? "p-invalid p-inputtext forminputtext-invalid"
                          : "p-inputtext forminputtext"
                      }
                      options={typeName}
                      value={selectedType}
                      onChange={(e) => {
                        const selectedType = e.value;
                        formik.setFieldValue("phc_type_id", selectedType.id);
                        formik.setFieldValue("phc_type_name", selectedType.label);
                        setSelectedType(selectedType);
                      }}
                      // onBlur={formik.handleBlur}
                    />
                    {formik.errors.phc_type_name &&
                      formik.touched.phc_type_name && (
                        <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                          {formik.errors.phc_type_name}
                        </span>
                      )}
                  </div>
                </div>

        <div className="grid flex align-items-center mt-5 gap-8">
          <div className="col-2 p-0 ml-8"></div>
          <div className="col p-0 flex justify-content-start">
            <Button type="submit" className="formbutton">
              Submit
            </Button>
          </div>
        </div>
      </form>

            <div  style={{ marginTop: "30px" }}>
              <DataTable
                value={filteredData}
                scrollHeight="350px"
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25, 50]}
                header={header}
                ref={dt}
                scrollable
              >
                <Column field="slno" header="Sl.No" />
                <Column field="fld_state_name" header="State Name"></Column>
                <Column field="fld_district_name" header="District Name"></Column>
                <Column field="fld_site_name" header="Site Name"></Column>
                <Column field="fld_taluk_name" header="Taluk Name"></Column>
                <Column field="fld_village_name" header="Village Name"></Column>
                <Column field="fld_phc_type_name" header="PHC Type"></Column>
                <Column field="fld_phc_name" header="PHC"></Column>
              </DataTable>
            </div>
    </div>
  )
}

export default GeoMaster